import Cookies from "js-cookie";

const TokenKey = "Authori-zation";

export function getToken() {
  return Cookies.get(TokenKey);
}

// export function setToken(token) {
//   return Cookies.set(TokenKey, token)
// }

export function setToken(token) {
  // 设置一个 Cookie，过期时间为 1 年后
  const expires = new Date();
  expires.setFullYear(expires.getFullYear() + 1);
  return Cookies.set(TokenKey, token, { expires: expires });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}
